// import React from 'react';
import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Siderbar/Sidebar';
import Header from '../components/Header/Header';
import { Outlet, useLocation } from 'react-router-dom';
import './MainLayout.css';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation(); // Get the current route location

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
    // Automatically close the sidebar on smaller screens when a link is clicked
    useEffect(() => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false);
      }
    }, [location]); // Trigger when the route changes
    
  return (
    <div className="main-layout">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Header toggleSidebar={toggleSidebar} />
        <div className="main-content">
          <Outlet /> {/* This will render the nested routes */}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;